import { type FC, useRef } from "react";

import { cn } from "../../utils/general";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "../collapsible";
import { useEmailDraft } from "./email-draft-context";
import { EmailDraftRecipientsDisplay } from "./email-draft-recipients-display";
import { EmailDraftRecipientsField } from "./email-draft-recipients-field";

export const EmailDraftRecipients: FC = () => {
  const toInputRef = useRef<HTMLInputElement>(null);
  const {
    handleUpdateRecipientsTo,
    handleUpdateRecipientsCc,
    handleUpdateRecipientsBcc,
    recipientsOpen,
    setRecipientsOpen,
    recipientsReadOnly,
    toReadOnly,
    showBcc,
    isEditable,
  } = useEmailDraft();

  if (recipientsReadOnly) {
    return (
      <div className="flex-none min-h-8 pb-2">
        <EmailDraftRecipientsDisplay />
      </div>
    );
  }

  const handleOpenChange = (open: boolean) => {
    if (!isEditable) {
      return;
    }

    setRecipientsOpen(open);
    setTimeout(() => toInputRef.current?.focus(), 25);
  };

  return (
    <div className="flex-none min-h-8 pb-2">
      <Collapsible className="group/collapsible" open={recipientsOpen} onOpenChange={handleOpenChange}>
        <CollapsibleTrigger
          onFocus={() => handleOpenChange(true)}
          tabIndex={0}
          asChild
          className={cn("w-full group-data-[state=open]/collapsible:hidden")}
        >
          <div>
            <EmailDraftRecipientsDisplay />
          </div>
        </CollapsibleTrigger>
        <CollapsibleContent>
          <div className="flex flex-col gap-1 py-0.5">
            <EmailDraftRecipientsField
              label="To"
              name="to"
              onChange={handleUpdateRecipientsTo}
              inputProps={{ ref: toInputRef }}
              disabled={!isEditable || toReadOnly}
            />
            <EmailDraftRecipientsField
              label="Cc"
              name="cc"
              onChange={handleUpdateRecipientsCc}
              disabled={!isEditable}
            />
            {showBcc && (
              <EmailDraftRecipientsField
                label="Bcc"
                name="bcc"
                onChange={handleUpdateRecipientsBcc}
                disabled={!isEditable}
              />
            )}
          </div>
        </CollapsibleContent>
      </Collapsible>
    </div>
  );
};
